export enum TimeType {
  FIXED_TIME = 'FIXED_TIME',
  INTERVAL_TIME = 'INTERVAL_TIME'
}

export class IntervalTime {
  public id?: string;
  public start?: string;
  public end?: string;
  public type = TimeType.INTERVAL_TIME as const;
}

export class FixedTime {
  public id?: string;
  public time?: string;
  public type = TimeType.FIXED_TIME as const;
}
